import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPin20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPin20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m12.766 9.921-.53.358-.108.628-.5 2.92a.503.503 0 0 1-.85.269L5.987 9.343a.497.497 0 0 1 .27-.843l2.945-.496.632-.107.361-.526 2.258-3.294a1.01 1.01 0 0 1 1.54-.144l2.24 2.22a.99.99 0 0 1-.146 1.529zm-6.76-2.894 2.944-.496 2.258-3.294a2.523 2.523 0 0 1 3.85-.36l2.24 2.22a2.477 2.477 0 0 1-.364 3.82l-3.321 2.24-.5 2.92c-.273 1.595-2.247 2.219-3.4 1.075l-1.801-1.786a1 1 0 0 1-.062.07L3.319 17.93a.757.757 0 0 1-1.065 0 .743.743 0 0 1 0-1.057l4.53-4.494a1 1 0 0 1 .071-.062L4.922 10.4c-1.153-1.143-.524-3.101 1.083-3.372"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPin20);
